import React from "react";

const UnassignDeviceModal = ({ isOpen, onClose,unassigncolumn, apiLoading, onUnassign }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-96 p-6 relative">
        {/* Header with Close Icon */}
        <div className="flex justify-between items-center border-b pb-3">
          <h2 className="text-lg font-bold">Confirmation</h2>
          <button
            className="text-gray-500 text-3xl hover:text-gray-800"
            onClick={() => onClose(false)}
          >
            &times;
          </button>
        </div>

        {/* Modal Content */}
        <p className="mt-4 text-gray-700">
          Are you sure you want to unassign the device?
        </p>

        {/* Footer with Buttons */}
        <div className="mt-6 flex justify-end">
          <button
            className={`${
              apiLoading ? "bg-gray-300 text-gray-500 cursor-not-allowed" : "bg-red-500 text-white hover:bg-red-600"
            } px-4 py-2 rounded-md`}
            onClick={()=>{unassigncolumn()}}
            disabled={apiLoading}
          >
            {apiLoading ? "UnAssigning..." : "Unassign"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnassignDeviceModal;
